import { Getter, ActionContext, Store } from 'vuex';
import { ISidebarHeader } from '@/shared/interfaces/sidebar-header-config';
import { TLanguage } from '@/shared';
import store from '../index';
import { storage } from '@/shared/helpers/storage';

type S = {};
type R = typeof store.state;

const getInitialUserSettings = () => storage.get('currentUserSettings') ?? {};

const state = {
  userSettings: getInitialUserSettings(),
};

export default {
  namespaced: true, // true = use 'root/' to prefix getters/actions/mutations

  state,

  getters: {
    // To root state
    isPendoInitialized: (_s: S, _g: unknown, rootState: R) => rootState.isPendoInitialized,
    s3Url: (_s: S, _g: unknown, rootState: R) => rootState.s3Url,
    logo: (_s: S, _g: unknown, rootState: R) => rootState.logo,
    language: (_s: S, _g: unknown, rootState: R) => rootState.language,
    loading: (_s: S, _g: unknown, rootState: R) => rootState.loading,
    isExpanded: (_s: S, _g: unknown, rootState: R) => rootState.isExpanded,

    // Direct to getters
    getLogo: (_s: S, _g: unknown, _rs: R, rootGetters: any): string => rootGetters.getLogo,
    sidebarHeaderData: (_s: S, _g: unknown, _rs: R, rootGetters: any): ISidebarHeader | {} => rootGetters.sidebarHeaderData,
    isTokenRequestInProgress: (_s: S, _g: unknown, _rs: R, rootGetters: any): boolean => rootGetters.isTokenRequestInProgress,

    userSettings: (gState: typeof state) => gState.userSettings ?? { useNewNav: true },
  },

  mutations: {
    setUserSettings(muState: typeof state, payload: Record<string, string | number | boolean>) {
      muState.userSettings = payload;
      storage.set('currentUserSettings', payload);
    },
  },

  actions: {
    setLoading(_ctx: ActionContext<S, R>, payload: boolean) {
      store.commit('setLoading', payload);
    },

    setIsTokenRequestInProgress(_ctx: ActionContext<S, R>, payload: boolean) {
      store.commit('setIsTokenRequestInProgress', payload);
    },

    setLanguage(_ctx: ActionContext<S, R>, payload: TLanguage) {
      store.commit('setLanguage', payload);
    },

    setSidebarHeaderData(_ctx: ActionContext<S, R>, payload: ISidebarHeader<Record<string, any>> | null) {
      store.commit('setSidebarHeaderData', payload);
    },

    setPendoInitialized(_ctx: ActionContext<S, R>, payload: boolean) {
      store.commit('setPendoInitialized', payload);
    },

    expandBlade(_ctx: ActionContext<S, R>, payload: boolean) {
      store.commit('expandBlade', payload);
    },

  },
};
